import { render } from "./TaxCard.vue?vue&type=template&id=2bd4ad95&scoped=true&ts=true"
import script from "./TaxCard.vue?vue&type=script&lang=ts"
export * from "./TaxCard.vue?vue&type=script&lang=ts"

import "./TaxCard.vue?vue&type=style&index=0&id=2bd4ad95&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/open_acc_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd4ad95"]])

export default __exports__